import React from 'react'
import OrderNotFound from '../not-found/not-found-card'

export default function NotFoundPage() {
  return <OrderNotFound title="404 - This page does not exist" />
}
